<div class="row">
  <div class="col-auto">
    <div class="sm-card-title-3 text-info font-weight-bold h6 mb-0 pb-0">
      <span class="font-weight-bold"> Boda
      </span>
      <span class="text-primary font-weight-bold">{{
        stages.boda
        }}</span>
    </div>
  </div>
  <div class="col-auto mx-xl-0 px-xl-0">
    <div class="sm-card-title-3 text-info font-weight-bold h6 mx-0 px-0">
      <span class="font-weight-bold"> Taxi</span>
      <span class="text-primary font-weight-bold mx-1">{{
        stages.taxi
        }}</span>
    </div>
  </div>
</div>